import * as d3 from 'd3';

export const tooltip = d3.select('body').append('div')
.attr('class', 'tooltip')
.style('position', 'fixed')
.style('background-color', 'white')
.style('border', '1px solid #A4B4CB')
.style('padding', '8px')
.style('border-radius', '4px')
.style('pointer-events', 'none')
.style("font-family", "PoppinsSemiBold")
.style("color", "#5D5E74")
.style("font-size", "12px");

export const formatValue = (value) => {
    if (value >= 10000000) {
      return `${(value / 10000000).toFixed(1)}C`; // Convert to crores
    } else if (value >= 1000) {
      return `${(value / 1000).toFixed(1)}K`; // Convert to thousands
    }
    return value; // Return value as is for smaller numbers
};